import type { SurveyDetails } from 'app/common/types/surveys'

import styles from './SurveyChart.module.scss'

export const SurveyChart = ({ data }: { data: SurveyDetails }) => {
  const values = data.aggregation.chartData.flatMap(point => [point.positive, point.negative])
  const max = Math.max(1, ...values)

  return (
    <div className={styles.scroll}>
      <div className={styles.chart}>
        <div className={styles.yAxis} aria-hidden>
          <span>{'10000'}</span><span>{'1000'}</span><span>{'500'}</span><span>{'100'}</span><span>{'50'}</span><span>{'0'}</span>
        </div>
        {data.aggregation.chartData.map(point => {
          const { positive, negative } = point
          return (
            <div key={point.label} className={styles.group} title={`${point.label}: ${point.total} ответов`}>
              <span className={`${styles.bar} ${styles.positive}`} style={{ height: `${Math.max(2, (positive / max) * 100)}%` }} title={`Положительные: ${positive}`} />
              <span className={`${styles.bar} ${styles.negative}`} style={{ height: `${Math.max(2, (negative / max) * 100)}%` }} title={`Отрицательные: ${negative}`} />
              <span className={styles.axisLabel}>{point.label}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
